// extracted by mini-css-extract-plugin
export default {"row":"styles_row__xRvTP","maintitle":"styles_maintitle__CTZHP","searchCol":"styles_searchCol__9wcp2"};